import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3e9067e5")
const _hoisted_1 = { class: "editTop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "editLabel" }, "Editar ficha", -1)
const _hoisted_3 = { class: "formMargin" }
const _hoisted_4 = { class: "formArea" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "formSubtitle" }, "Nombre de la empresa *", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "formSubtitle" }, "Sector *", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "formSubtitle" }, "Logo de la empresa *", -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = { class: "publishedOffers" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: _ctx.JobBankRouteNames.COMPANIES}))),
        icon: "pi pi-arrow-left",
        class: "p-button-rounded p-button-text"
      }),
      _hoisted_2,
      _createVNode(_component_Button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name: _ctx.JobBankRouteNames.EDIT_COMPANY}))),
        label: "Editar",
        class: "p-button-link flexEnd"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            class: "box-size inputText",
            placeholder: _ctx.formData.name,
            disabled: ""
          }, null, 8, ["placeholder"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            class: "box-size, dl",
            placeholder: _ctx.formData.sector,
            disabled: ""
          }, null, 8, ["placeholder"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("img", {
            class: "imageSize",
            src: _ctx.formData.logo,
            alt: ""
          }, null, 8, _hoisted_8)
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", null, _toDisplayString(_ctx.jobOfferCardCount) + " ofertas laborales publicadas", 1)
      ])
    ])
  ]))
}